<template>
  <div class="rounded-md bg-gray-lighten3 text-slate">
    <div>
      <button
        class="relative flex min-h-[61px] w-full items-center py-4 pl-6 pr-[72px] text-left text-md font-bold md:min-h-[65px] xl:min-h-[72px]"
        @click.prevent="toggleItem()"
      >
        <slot name="title"></slot>

        <div
          class="absolute right-4 top-1/2 h-6 w-6 -translate-y-1/2 text-blue"
        >
          <UiIcon
            :icon="isOpen ? 'chevronUpBig' : 'chevronDownBig'"
            container-size
          ></UiIcon>
        </div>
      </button>
    </div>

    <div v-if="isOpen" class="px-6 pb-6">
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useToggle } from '@vueuse/core';

const isOpen = ref(false);
const toggleItem = useToggle(isOpen);
</script>
